import { types } from 'mobx-state-tree';

/**
 * Credit Card model.
 */
export const CreditCardModel = types.model('CreditCard', {
  cardType: types.string,
  expirationDate: types.string,
  expirationMonth: types.string,
  expirationYear: types.string,
  id: types.string,
  imageUrl: types.maybeNull(types.string),
  isDefault: types.boolean,
  isExpired: types.maybe(types.boolean),
  label: types.string,
  lastFour: types.string,
  mask: types.maybe(types.string),
  token: types.string,
});
